"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockedRectContext = exports.BlockingContentProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function BlockingContentProvider({ children }) {
    const [blockedRects, setBlockedRects] = react_1.useState([]);
    const value = react_1.useMemo(() => ({ setBlockedRects, blockedRects }), [blockedRects]);
    return jsx_runtime_1.jsx(exports.BlockedRectContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.BlockingContentProvider = BlockingContentProvider;
exports.BlockedRectContext = react_1.createContext({
    blockedRects: [],
    setBlockedRects: () => {
        throw new Error('Use BlockedRectProvider.');
    },
});
//# sourceMappingURL=index.js.map